/**
 * Carousels témoignages — data-carousel.
 */
export default function initTestimonials() {
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('.testimonials__track');
    const slides = carousel.querySelectorAll('.testimonials__slide');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track || !slides.length) {
      return;
    }

    let currentIndex = 0;

    const getVisibleCount = () => {
      if (window.innerWidth >= 1024) {
        return Math.min(3, slides.length);
      }
      if (window.innerWidth >= 768) {
        return Math.min(2, slides.length);
      }
      return 1;
    };

    const getMaxIndex = () => Math.max(0, slides.length - getVisibleCount());

    const updateCarousel = () => {
      const maxIndex = getMaxIndex();
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }
      track.style.transform = `translateX(-${currentIndex * slides[0].offsetWidth}px)`;
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
      }
    };

    prevBtn?.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex -= 1;
        updateCarousel();
      }
    });

    nextBtn?.addEventListener('click', () => {
      if (currentIndex < getMaxIndex()) {
        currentIndex += 1;
        updateCarousel();
      }
    });

    window.addEventListener('resize', updateCarousel);
    updateCarousel();
  });
}
